import api from "./api";

class AppointedService{
    getDataPage(data){
        return api
            .get("/appointed/paginate",{
                params: data
              })
            .then((response) => {
                return response;
            });
    }
   
    destroy(id) {
        return api
        .delete("/appointed/"+id)
        .then((response) => {
            return response;
        });
    }

    getListUser(idItem){
        return api
            .get("/user/list?id="+idItem)
            .then((response) => {
                return response;
            });
    }
    
    getJobPositonList(){
        return api
            .get("/organization/job-position/all")
            .then((response) => {
                return response;
            });
    }
    getDepartmentList(){
        return api
            .get("/organization/departments/all")
            .then((response) => {
                return response;
            });
    }
    
    getItem(id){
        return api
            .get("/appointed/"+id)
            .then((response) => {
                return response;
            });
    }
    
    updateOrCreate(item) {
        if(item.id){
            return api
                .put("/appointed/"+item.id, item)
                .then((response) => {
                    return response;
                });
        }
        return api
            .post("/appointed", item)
            .then((response) => {
                return response;
            });
    }
    
    updateProfile(id) {
        return api
            .put("/appointed/update-profile/"+id)
            .then((response) => {
                return response;
            });
    }
    
}

export default new AppointedService();